module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg4_mid.ff7a0ec9.jpg";